import cx from 'classnames';
import {
    ASK_AN_EXPERT,
    BADGE_REDACTION,
    CONTESTS,
    HOME_SHOW_MORE_POSTS,
    HOMEPAGE_FEED_NAV_TAB_FORUM,
    HOMEPAGE_FEED_NAV_TAB_PHOTOBLOGS,
    HOMEPAGE_NEW_ANNOUNCEMENT,
    HOMEPAGE_NEW_CONTACT_FORM,
    HOMEPAGE_NEW_CONTACT_FORM_LINK,
    HOMEPAGE_NEW_CONTACT_FORM_LINK_URL,
    HOMEPAGE_OLD_SWITCH,
    MAIN_MENU_REVIEWS,
} from 'mk/autogenerated/translations/Home2.a4b31b08ba09274de35ff5f8264ff6a8'
import { MAGAZINE_USER } from 'mk2/apps/blogs/constants';
import { blogsPopularFeedUrl, blogsProfileUrl } from 'mk2/apps/blogs/urls';
import { contestsHomeUrl } from 'mk2/apps/contests/urls';
import { counsellingsHomeUrl } from 'mk2/apps/counsellings/urls';
import { forumUrl } from 'mk2/apps/forum/urls';
import Bazaar2, { Bazaar2Placeholder } from 'mk2/apps/home/components/Bazaar2';
import { HomepagePost2, HomepagePost2Placeholder } from 'mk2/apps/home/components/HomepagePost2';
import { HOME_LOAD_PAGE_TRIGGER } from 'mk2/apps/home/containers/Home2/Home2.actions';
import { Props } from 'mk2/apps/home/containers/Home2/Home2Page';
import { homepageUrl } from 'mk2/apps/home/urls';
import { getHpID } from 'mk2/apps/home/utils';
import { WIKI_REVIEWS_ARTICLE_SLUG } from 'mk2/apps/wiki/helpers';
import { getWikiArticleUrl } from 'mk2/apps/wiki/urls';
import AnnouncementBox, { BoxType } from 'mk2/components/AnnouncementBox';
import { Btn, BtnType } from 'mk2/components/Btn';
import { Link } from 'mk2/components/Link';
import { TrackClick } from 'mk2/components/TrackClick';
import ActionButton from 'mk2/containers/ActionButton/ActionButton';
import { AdSlot } from 'mk2/containers/AdSlot/AdSlot';
import { LoadingSwitch } from 'mk2/containers/LoadingSwitch/LoadingSwitch';
import { url } from 'mk2/helpers/urls';
import { isLoading, LoadingState } from 'mk2/reducers/loadingState';
import React from 'react';
import styles from './Home2.mscss';

export const NEW_HP = 'HP_NEW';
export const OLD_HP = 'HP_OLD';

interface State {
    client: boolean;
}

const TABS = [
  {
      label: HOMEPAGE_FEED_NAV_TAB_FORUM,
      href: forumUrl,
      style: styles.Home2__types__forum__topBorder,
  },
  {
      label: HOMEPAGE_FEED_NAV_TAB_PHOTOBLOGS,
      href: blogsPopularFeedUrl,
      style: styles.Home2__types__photoblogs__topBorder,
  },
  {
      label: MAIN_MENU_REVIEWS,
      href: getWikiArticleUrl(WIKI_REVIEWS_ARTICLE_SLUG, WIKI_REVIEWS_ARTICLE_SLUG),
      style: styles.Home2__types__reviews__topBorder,
  },
  {
      label: ASK_AN_EXPERT,
      href: counsellingsHomeUrl,
      style: styles.Home2__types__counsellings__topBorder,
  },
  {
      label: CONTESTS,
      href: contestsHomeUrl,
      style: styles.Home2__types__contests__topBorder,
  },
  {
      label: BADGE_REDACTION,
      href: url(blogsProfileUrl, { username: MAGAZINE_USER }),
      style: styles.Home2__types__modrykonik__topBorder,
  },
];

declare var window: any;

function gtag(..._args: any[]): void {
  window.dataLayer.push(arguments);
}

class Home2 extends React.PureComponent<Props> {

    public state: State = {
        client: false,
    };

    private observer: IntersectionObserver | null = null;
    private observedElements = new Map<string, HTMLElement>();

    private flushInterval: number | undefined;
    private visibilityMap: Map<string, { visibleSince: number | null; accumulated: number; hideTimeout?: number }> = new Map();
    private pendingReportPosts = new Set<string>();
    private reportedPostIds = new Set<string>(); // nová sada na ne-duplicitné zaznamenávanie

    public render() {
        const { loadingState, homePosts } = this.props;

        return (
            <div className={styles.Home2} key={'hinner2'}>
                <LoadingSwitch
                    loadingState={loadingState}
                    onLoad={this.load}
                    onRenderSuccess={this.renderInitSuccess}
                    onRenderInit={this.renderInitSuccess}
                    hasData={homePosts && homePosts.length > 0}
                />
            </div>
        );
    }

    public componentDidMount(): void {
        if (typeof window !== 'undefined') {
            window.dataLayer = window.dataLayer || [];
            window.gtag = window.gtag || gtag;
            gtag('set', 'user_properties', {
              'homepage_ab': NEW_HP,
            });
        }

        this.setState({ client: true });

        this.observer = new IntersectionObserver(this.handleIntersections, {
            threshold: [0.5],
        });

        this.flushInterval = window.setInterval(() => {
            this.flushSeenPosts();
        }, 1000);
    }

    public componentWillUnmount(): void {
        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }

        if (this.flushInterval) {
            clearInterval(this.flushInterval);
        }

        this.visibilityMap.clear();
        this.pendingReportPosts.clear();
    }

    private handleForceHomepageAB = () => {
        this.props.onAbSet('homepageAB', OLD_HP);
    };

    private onPostVisible = (postId: string) => {
        this.pendingReportPosts.add(postId);
    };

    private handleIntersections = (entries: IntersectionObserverEntry[]) => {
        const now = performance.now();
        entries.forEach(entry => {
            const target = entry.target as HTMLElement;
            const postId = target.dataset.postId;
            if (!postId) return;

            let vis = this.visibilityMap.get(postId);
            if (!vis) {
                vis = { visibleSince: null, accumulated: 0 };
                this.visibilityMap.set(postId, vis);
            }

            if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
                // Ak sa práve začalo zobrazovať, nastav čas
                if (vis.visibleSince === null) {
                    vis.visibleSince = now;
                }
            } else {
                // Ak prestal byť viditeľný, spočítaj čas a zresetuj visibleSince
                if (vis.visibleSince !== null) {
                    vis.accumulated += (now - vis.visibleSince);
                    vis.visibleSince = null;
                }
            }

            // Ak je viditeľný práve teraz, aj aktualizuj čas
            if (vis.visibleSince !== null) {
                vis.accumulated += (now - vis.visibleSince);
                vis.visibleSince = now;
            }

            // Ak prekročil limit a ešte sme ho nereportovali
            if (vis.accumulated >= 2000 && !this.reportedPostIds.has(postId)) {
                this.onPostVisible(postId);
                this.reportedPostIds.add(postId);
                this.visibilityMap.delete(postId);
            }
        });
    };

    private flushSeenPosts = () => {
        const { onCheckout } = this.props;
        if (this.pendingReportPosts.size === 0) return;
        onCheckout(Array.from(this.pendingReportPosts));
        this.pendingReportPosts.clear();
    };

    private observePostElement = (element: HTMLElement | null, postId: string) => {
        if (!this.observer) return;

        // Ak už element existuje, najprv odsledovať starý (napr. zmeny refs)
        const oldEl = this.observedElements.get(postId);
        if (oldEl && oldEl !== element) {
            this.observer.unobserve(oldEl);
        }

        if (element) {
            this.observer.observe(element);
            this.observedElements.set(postId, element);
        } else {
            // Element sa odobral, treba aj z mapy vymazať a unobserve
            if (oldEl) {
                this.observer.unobserve(oldEl);
                this.observedElements.delete(postId);
            }
        }
    };

    private load = () => {
        const { onLoad, location, page, fromPage } = this.props;
        onLoad(location, page, fromPage);
    };

    private renderInitSuccess = () => {
        const {
            isMobile,
            loadingState,
            requestUser,
            history,
            bazaarCounts,
            place,
            homePosts,
            showAds,
            location,
            nextPage,
            pageLoadingState,
            onFollowUser,
            onSubscribeTopic,
        } = this.props;

        const inFeedAdSlotZones: string[] = [
            `Homepage - Top (${isMobile ? 'Mobile' : 'Desktop'})`,
            `Homepage - Mid 01 (${isMobile ? 'Mobile' : 'Desktop'})`,
            `Homepage - Mid 02 (${isMobile ? 'Mobile' : 'Desktop'})`,
            `Homepage - Mid 03 (${isMobile ? 'Mobile' : 'Desktop'})`,
            `Homepage - Mid 04 (${isMobile ? 'Mobile' : 'Desktop'})`,
            `Homepage - Mid 05 (${isMobile ? 'Mobile' : 'Desktop'})`,
            `Homepage - Mid 06 (${isMobile ? 'Mobile' : 'Desktop'})`,
        ];

        return (
            <>
                <div className={styles.Home2__announcement}>
                    <AnnouncementBox
                        type={BoxType.Homepage}
                        message={HOMEPAGE_NEW_ANNOUNCEMENT}
                        key={'announce2'}
                        detailMessage={
                            <div>
                                {HOMEPAGE_NEW_CONTACT_FORM}&nbsp;
                                <Link
                                    to={HOMEPAGE_NEW_CONTACT_FORM_LINK_URL}
                                    target="_blank"
                                >
                                    {HOMEPAGE_NEW_CONTACT_FORM_LINK}
                                </Link>
                            </div>}
                        hasDetailMessage
                        actions={
                            <Btn
                                type={BtnType.Blue}
                                label={HOMEPAGE_OLD_SWITCH}
                                onClick={this.handleForceHomepageAB}
                            />
                        }
                    />
                </div>

                {isLoading(loadingState) ? (
                    <Bazaar2Placeholder key={'Bazaar2Placeholder'} className={styles.Home2__bazaar} isMobile={isMobile} history={history} />
                ) : (
                    <Bazaar2
                        key={'bazaar2'}
                        className={styles.Home2__bazaar}
                        history={history}
                        isMobile={isMobile}
                        prams={bazaarCounts.prams}
                        footwear={bazaarCounts.footwear}
                        toys={bazaarCounts.toys}
                        others={bazaarCounts.others}
                        places={bazaarCounts.places}
                        place={place}
                        requestUser={requestUser}
                    />
                )}

                <NavigationTabs />

                <div className={styles.Home2__posts}>
                    {homePosts.map((post, index) => {
                        let showAdSlot = showAds && (index - 1) % 6 === 0;
                        let zone = null;
                        if (showAdSlot) {
                            zone = inFeedAdSlotZones.shift() || null;
                        }
                        if (!zone) {
                            showAdSlot = false;
                        }

                        return (
                            <div
                                key={`wrp-${index}-${post.id}`}
                                data-post-id={getHpID(post)}
                                ref={(el) => {
                                    this.observePostElement(el, String(post.id));
                                }}
                            >
                                {showAdSlot && (
                                    <div>
                                        <AdSlot
                                            zone={zone}
                                            location={location}
                                            marginTopWithAd={10}
                                        />
                                    </div>
                                )}
                                <TrackClick
                                    name="homepage_feed_click"
                                    props={{
                                        id: post.id,
                                        url: post.url,
                                        position: index + 1,
                                    }}
                                    key={`tc-${index}-${post.id}`}
                                >
                                    <HomepagePost2
                                        className={styles.Home2__post}
                                        post={post}
                                        requestUser={requestUser}
                                        isMobile={isMobile}
                                        onRendered={null}
                                        onFollowUser={onFollowUser}
                                        onSubscribeTopic={onSubscribeTopic}
                                        history={history}
                                    />
                                </TrackClick>
                            </div>
                        );
                    })}
                </div>

                {isLoading(loadingState) && (
                    <>
                        <HomepagePost2Placeholder />
                        <HomepagePost2Placeholder />
                        <HomepagePost2Placeholder />
                        <HomepagePost2Placeholder />
                        <HomepagePost2Placeholder />
                        <HomepagePost2Placeholder />
                        <HomepagePost2Placeholder />
                    </>
                )}

                <div className={styles.Home2__loadMore}>
                    <ActionButton
                        type={BtnType.Blue}
                        link={url(homepageUrl, null, {page: nextPage, fromPage: 1})}
                        replace
                        label={HOME_SHOW_MORE_POSTS}
                        triggerAction={HOME_LOAD_PAGE_TRIGGER}
                        onClick={this.handleLoadMore}
                        showSpinnerWhenBusy
                        disabled={!nextPage || pageLoadingState === LoadingState.LOADING}
                    />
                </div>
            </>
        );
    };

    private handleLoadMore = () => {
        const {nextPage, pageLoadingState, onLoadPage} = this.props;
        if (nextPage && pageLoadingState !== LoadingState.LOADING) {
            onLoadPage(nextPage);
        }
        return Promise.resolve();
    };
}

export default Home2;


const NavigationTabs: React.FC = () => {
    return (
        <nav
            className={styles.Home2__tabs}
            role="tablist"
            aria-label="homepage navigation"
        >
            {TABS.map((tab, index) => (
                <Link
                    key={index}
                    to={tab.href}
                    className={cx(
                        styles.Home2__tab,
                        tab.style,
                    )}
                >
                    {tab.label}
                </Link>
            ))}
        </nav>
    );
};
